import React from 'react';
import { FileText, Check, X, UploadCloud, Circle, CheckCircle, XCircle, Trash2, Download } from 'lucide-react';
import {
  ItemWrapper,
  FileInfo,
  FileLink,
  FileName,
  FileIcon,
  ActionsContainer,
  ActionButton,
  StatusDisplay,
  DownloadLinkButton,
  Thumbnail
} from './DocumentItem.styles';

// This is a small, internal component for displaying the status.
const Status = ({ status }) => {
  const statusConfig = {
    Pending: { icon: <Circle size={16} />, color: '#ff9500' },
    'Entered in Tally': { icon: <CheckCircle size={16} />, color: '#34c759' },
    Rejected: { icon: <XCircle size={16} />, color: '#ff3b30' },
  };
  const currentStatus = statusConfig[status] || statusConfig.Pending;
  return (
    <StatusDisplay color={currentStatus.color}>
      {currentStatus.icon}
      <span>{status}</span>
    </StatusDisplay>
  );
};

// The main DocumentItem component
const DocumentItem = ({ document, userRole, onUpdateStatus, onReUpload, onDelete }) => {
  // Switched back to http as per your last instruction
  const isActionable = document.status === 'Pending' && userRole === 'data-entry';
  const isRejected = document.status === 'Rejected' && userRole === 'client';
  const canBeDeleted = (document.status === 'Rejected' || document.status === 'Entered in Tally') && userRole === 'data-entry';

  const isImage = (fileName = '') => {
    return /\.(jpg|jpeg|png|gif)$/i.test(fileName);
  };

  // Stop link navigation when a button inside it is clicked
  const handleActionClick = (e, action) => {
    e.preventDefault();
    e.stopPropagation();
    action();
  }

  return (
    <ItemWrapper $status={document.status}>
      {/* The main link now points to the public downloadURL */}
      <FileLink href={document.downloadURL} target="_blank" rel="noopener noreferrer">
        {isImage(document.fileName) ? (
          // The thumbnail source is also the downloadURL
          <Thumbnail src={document.downloadURL} alt="thumbnail" />
        ) : (
          <FileIcon><FileText size={24} /></FileIcon>
        )}
        <FileName>{document.fileName}</FileName>
      </FileLink>
      
      <ActionsContainer>
        <Status status={document.status} />

        {/* The download button also uses the downloadURL */}
        {userRole === 'data-entry' && (
          <DownloadLinkButton 
            href={document.downloadURL} 
            download={document.fileName} // 'download' attribute forces download
            onClick={(e) => e.stopPropagation()}
          >
            <Download size={16} />
          </DownloadLinkButton>
        )}

        {isActionable && (
          <>
            <ActionButton className="approve" onClick={(e) => handleActionClick(e, () => onUpdateStatus(document.id, 'Entered in Tally'))}><Check size={16} /></ActionButton>
            <ActionButton className="reject" onClick={(e) => handleActionClick(e, () => onUpdateStatus(document.id, 'Rejected'))}><X size={16} /></ActionButton>
          </>
        )}
        {isRejected && (
          <ActionButton onClick={(e) => handleActionClick(e, () => onReUpload(document))}>
            <UploadCloud size={16} /> Re-upload
          </ActionButton>
        )}
        {canBeDeleted && (
           <ActionButton className="reject" onClick={(e) => handleActionClick(e, () => onDelete(document))}>
             <Trash2 size={16} />
           </ActionButton>
        )}
      </ActionsContainer>
    </ItemWrapper>
  );
};

// --- FIX IS HERE: ADD THE MISSING EXPORT STATEMENTS ---
export { Status }; // Export Status as a named export in case we need it elsewhere
export default DocumentItem; // Export DocumentItem as the default export